// Prompts offered one at a time as a tip above an empty dashboard agent chat. The point is to show how
// much the agent already knows about this client and can do with it — questions people wouldn't
// think to just ask. Clicking one fills the prompt box. Each should be answerable from the agent's own
// tools.
export const DASHBOARD_AGENT_TIPS = [
  "What do you know about my client's data?",
  'What kinds of charts can you build?',
  'What kinds of questions can I ask you?',
  'What types of queries can you build?',
  'What are my dimensions?',
  'What can I filter by?',
  'Build a chart comparing data across sources'
] as const;
